export default __webpack_public_path__ + "static/media/logo-white.d51fd0f5.svg";